import { createReducer, on } from '@ngrx/store'
import { AppStatus } from '@papi/interfaces'
import * as AppActions from '../apps/app.actions'
import * as AuthActions from './auth.actions'
import { AuthUser } from './auth.service'

export const authFeatureKey = 'auth'

export interface AuthState {
  token?: string
  user?: AuthUser
  ready?: boolean
}

export const initialState: AuthState = {}

export const reducer = createReducer(
  initialState,

  on(AuthActions.logout, (state) => ({
    ...state,
    token: undefined,
    user: undefined,
  })),
  on(AuthActions.autologin, AuthActions.login, (state) => ({
    ...state,
    ready: false,
    token: undefined,
    user: undefined,
  })),
  on(AuthActions.loginSuccess, (state, action) => ({
    ...state,
    ready: true,
    token: action.output.token,
    user: action.output.user,
  })),
  on(AuthActions.loginFailure, (state) => ({
    ...state,
    ready: true,
  })),
  on(AppActions.receivedApp, (state, action) => {
    if (!action.app) return state
    return {
      ...state,
      user: {
        ...state.user,
        partners: state.user.partners.map((partner) => {
          if (action.app.partnerId !== partner._id) return partner
          const existing = partner.apps.find((a) => a._id === action.app._id)
          const apps = existing
            ? partner.apps.map((a) => (a._id === action.app._id ? { ...a, ...action.app } : a))
            : [...partner.apps, action.app]
          return { ...partner, apps }
        }),
      },
    }
  }),
  on(AppActions.deletedApp, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        partners: state.user.partners.map((partner) => {
          if (partner.apps.every(rejectAppId)) return partner
          return { ...partner, apps: partner.apps.filter(rejectAppId) }
        }),
      },
    }

    function rejectAppId(a) {
      return a._id !== action.appId
    }
  }),
  on(AppActions.activateApp, setAppStatus(AppStatus.ACTIVE)),
  on(AppActions.deactivateApp, setAppStatus(AppStatus.INACTIVE))
)

function setAppStatus(status: AppStatus) {
  return (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        partners: state.user.partners.map((partner) => {
          const existing = partner.apps.find((a) => a._id === action.appId)
          if (!existing) return partner
          const apps = partner.apps.map((a) => (a._id === action.appId ? { ...a, status } : a))
          return { ...partner, apps }
        }),
      },
    }
  }
}
